import React, { forwardRef } from 'react';
import { isBrowser } from '@ux/component-utilities';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Tray component.
 *
 * This is the actual tray that the dropdown menu opens up. It is where the
 * content of the dropdown is rendered.
 *
 * @class Tray
 * @public
 */
const Tray = forwardRef(function Tray({ className, children, open, renderClosed }, ref) {
  const renderChildren = open || renderClosed;

  return (
    <div ref={ ref } className={ classnames(className, 'tray-dropdown', isBrowser() && 'loaded') }>
      {renderChildren && (
        <div className='tray-content'>{children}</div>
      )}
    </div>
  );
});

export default Tray;

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
Tray.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  open: PropTypes.bool,
  renderClosed: PropTypes.bool
};
